import PropTypes from 'prop-types';
import { Flyout } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import { hideFlyout } from '../../../Dashboard/actions';
import { setCurrentVisitsDetails } from '../../actions';
import VisitTabs from '../VisitsTabs';

import styles from './VisitsFlyout.module.scss';

const VisitsFlyout = ({ show }) => {
  const dispatchHideFlyout = useAction(hideFlyout);
  const dispatchClearDetailsData = useAction(setCurrentVisitsDetails);

  const handleOnCloseFlyout = () => {
    dispatchHideFlyout();
    dispatchClearDetailsData();
  };

  return (
    <Flyout
      show={show}
      overlayClassName={styles.visitFlyout}
      heading="Record Details"
      onCloseClick={handleOnCloseFlyout}
    >
      <VisitTabs />
    </Flyout>
  );
};

VisitsFlyout.propTypes = {
  show: PropTypes.bool,
};

VisitsFlyout.defaultProps = {
  show: '',
};

export default VisitsFlyout;
